"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.angleLeft = void 0;
var angleLeft = {
  "viewBox": "0 0 640 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M627 544q0 13-10 23l-393 393 393 393q10 10 10 23t-10 23l-50 50q-10 10-23 10t-23-10l-466-466q-10-10-10-23t10-23l466-466q10-10 23-10t23 10l50 50q10 10 10 23z"
    }
  }]
};
exports.angleLeft = angleLeft;